
import { OnInit, Component, ElementRef, ViewChild } from '@angular/core';
import {
    EASY_MIGRATION_IMAGE_PATH,
    LEADERSHIPBG,
    MILINDPHOTO, JYOTISHPHOTO,
    ATULPIMPLEPHOTO,
    ASHEERKAPOORPHOTO,
    LINKEDINICON,
    LEADING_BANNER_NEW,
    ATUL_SIR_NEW_PIC,
    MILIND_SIR_NEW_PIC,
    MUKTAAKAMPLIKAR,
    Abhinesh,
    SOURABH,
    Harshad,
    jitendra,
    SANJEEVSABHARWAL,
    GANESHNATRAJAN,
    POOJAPHOTO,
    AAMODPHOTO,
    Archana,
    NITIKSHAPHOTO,
    RAHULPHOTO,
    BALAPHOTO
} from '../../../assets/assets_constant';
@Component({
    selector: 'app-leadership-and-philosophy',
    templateUrl: './leadership-and-philosophy.component.html',
    styleUrls: ['./leadership-and-philosophy.component.css']
})
export class LeadershipAndPhilosophyComponent implements OnInit {
    imagePath = EASY_MIGRATION_IMAGE_PATH;
    bannerImage: String = LEADING_BANNER_NEW;
    asheerPhoto = ASHEERKAPOORPHOTO;
    atulPhoto = ATUL_SIR_NEW_PIC;
    sanjeevphoto = SANJEEVSABHARWAL;
    milindPhoto = MILIND_SIR_NEW_PIC;
    muktaphoto = MUKTAAKAMPLIKAR;
    jyotishPhoto = JYOTISHPHOTO;
    ganeshPhoto = GANESHNATRAJAN;
    poojaphoto = POOJAPHOTO;
    Abhinesh = Abhinesh;
    Sourabh = SOURABH;
    Harshad = Harshad;
    jitendra = jitendra;
    AAMODPHOTO = AAMODPHOTO;
    Archana = Archana;
    nitiksha = NITIKSHAPHOTO;
    rahul = RAHULPHOTO;
    balaphoto = BALAPHOTO;


      showMore: boolean[] = [];  // Track each card's expanded state

     @ViewChild('leadersRow') leadersRow!: ElementRef;


  leaders = [
    {
      img: this.Archana,
      name: "Archana Shiledar",
      post: "Chief Financial Officer",
      info: "A 45-year-old ACA and M.Com graduate with distinction from Pune University, appointed CFO on 03.02.2025. With 20+ years in finance, accounts, and compliance, she excels in leadership, IFRS, and auditing, bringing both auditor and management perspectives to the organization."
    },
    {
      img: this.Sourabh,
      name: "Sourabh Jain",
      post: "Product Owner",
      info: "Sourabh Jain, aged about 32 years, was  appointed as Product Owner w.e.f. July 2016. He is a Chartered Accountant and graduate in Commerce from Mumbai University. He is highly motivated and results-driven Product Owner with 8+  Years of experience in leading cross-functional teams to deliver successful software products."
    },
    {
      img: this.Abhinesh,
      name: "Abhinesh Kumar",
      post: "Principal Architect",
      info: "Abhinesh Kumar , aged about 39 years, is appointed as Principal Architect. He is Post Graduate in Master of Science (MSc), Computer Science from Maharshi Dayanand University and also Master in Computer Applications (MCA) in Commerce."
    },
    {
      img: this.rahul,
      name: "Kumar Rishikant",
      post: "Head – Human Resources",
      info: "Kumar Rishikant, who has joined us as Head – Human Resources on 7th April 2025.He brings over 15 years of rich HR experience, having led key functions such as HR business partnering, performance management, employee engagement, grievance handling, and talent development. His most recent role was at Hexaview Technologies, where he headed the HR and Admin functions. Kumar Rishikant holds an MBA in HR from ICFAI Business School, Ahmedabad and is currently pursuing a Ph.D. from ICFAI University Jharkhand. He is also certified in Data Analytics (IIM Rohtak) and is a proud member of SHRM."
    },
    {
      img: this.nitiksha,
      name: "Nitiksha Khandelwal",
      post: "Company Secretary & Compliance Officer",
      info: "Nitiksha Khandelwal, aged 28, was appointed as the Company Secretary. She holds qualifications as a Company Secretary (CS) and a Masters of Commerce. A highly skilled professional, she brings extensive experience in legal and secretarial matters.  Nitiksha Khandelwal has a proven track record of  successfully and efficiently managing various legal obligations and compliances. She has been associated  with our organization since the initiation of our IPO planning process."
    }
  ];

  constructor() {
    // Initialize "showMore" array with false for each leader
    this.showMore = this.leaders.map(() => false);
  }

  toggleReadMore(index: number) {
    this.showMore[index] = !this.showMore[index];
  }

      scrollLeft() {
    this.leadersRow.nativeElement.scrollBy({
      left: -350,
      behavior: 'smooth'
    });
  }

  scrollRight() {
    this.leadersRow.nativeElement.scrollBy({
      left: 350,
      behavior: 'smooth'
    });
  }



    // constructor() { }

    ngOnInit() {
    }

}
